// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const ResultsFeed = () => ({
   replace: true,
   controller: 'ResultsFeedCtrl',
   templateUrl: '/assets/resultsFeed.html'
})

const DocumentDirective = () => ({
   priority: 10,

   link: {
      pre(scope: any, element: any, attrs: any) {
         return scope.document = scope.$eval(attrs.document)
      }
   }
})

// @ts-expect-error TS(7006) FIXME: Parameter 'docService' implicitly has an 'any' typ... Remove this comment to see the full error message
const DocumentSummary = (docService, quickLookService, config, journalCoverageDetailsService, translationService) => ({
   replace: true,
   templateUrl: '/assets/documentSummary.html',
   scope: true,

   link: {
      pre(scope: any, element: any, attr: any) {
  
         const resultsConfig = config.data.results
         const {
            libHash
         } = config.data.availability
    
         scope.headingLevel = attr.headingLevel || 'h3'
         scope.showQuickLook = !!(attr.showQuicklook || false)
         scope.showRelated = !!(attr.showRelated || false)
         scope.resultNumber = !!(attr.resultNumber || false)

         // this function is repeated in traAvailabilityDirective.ts, availabilityDirective.ts and resultsFeedDirective.ts - i tried to make this a gloabl 
         // function but ran into annoying infinite digest loops which would crash the UI.
         scope.getCombinedContentTypes = function(doc: any) {
            if (!doc || !doc.content_type) return ''
            const types: string[] = []
            types.push(translationService.translate(doc.content_type))
            if (doc.additional_content_types && doc.additional_content_types.length > 0) {
               doc.additional_content_types.forEach((type: string) => {
                  types.push(translationService.translate(type))
               })
            }
            return types.join(' / ')
         }

         const doc = scope.document
         const hasIssns = doc.issns && doc.issns.length

         scope.isMobile = window.innerWidth < 700 

         doc.thumbnail_small_for_mobile_only = doc.thumbnail_small

         if (!doc.thumbnail_small) { doc.thumbnail_small = false }
         if (!doc.thumbnail_medium) { doc.thumbnail_medium = false }
         if (!doc.thumbnail_large) { doc.thumbnail_large = false }

         // if the small thumbnail isn't available, try the larger versions
         if (!doc.thumbnail_small) {
            doc.thumbnail_small = doc.thumbnail_medium
         }
         if (!doc.thumbnail_small) {
            doc.thumbnail_small = doc.thumbnail_large
         }

         doc.hasDetailPage = doc.hasDetailPage ?? (docService.displayDetailPage(doc) || docService.displayAIPage(doc))
         scope.summary = docService.getDocumentSummary(doc)
         scope.availabilityDocs = [doc].concat(doc.peer_documents || [])
         scope.authors = docService.getAuthors(doc)
         scope.altmetrics = config.data.altmetrics
         scope.journalTitleSearchLink = resultsConfig.enableJournalTitleLink && docService.getJournalTitleSearchLink(doc)
         scope.displayOpenAccessIndicator = resultsConfig.displayOpenAccessIndicator && doc.is_open_access
         scope.addOpenAccessLink = resultsConfig.addOpenAccessLink && doc.open_access_link
         scope.displayPeerReviewIndicator = resultsConfig.displayPeerReviewIndicator && doc.is_peer_reviewed
         scope.displayOnlineIndicator = resultsConfig.displayOnlineIndicator
         scope.displayRelatedItemsLink = resultsConfig.displayRelatedItems
         scope.displayPdfQuickLinks = resultsConfig.displayPdfQuickLinks
         scope.displayHtmlQuickLinks = resultsConfig.displayHtmlQuickLinks
         scope.displayEditor = resultsConfig.displayEditor
         scope.displayDocInsights = resultsConfig.displayDocInsights

         scope.maximumFullTextLinks = resultsConfig.maximumFullTextLinks
         scope.enableAdditionalFullTextLinks = resultsConfig.enableAdditionalFullTextLinks
         scope.displayMultipleFullTextLinks = (scope.maximumFullTextLinks > 1) && scope.enableAdditionalFullTextLinks
         scope.displayLinkResolver =  resultsConfig.displayLinkResolver

         scope.showDocumentGlanceability = docService.showDocumentGlanceability
         scope.getDocumentGlancebilityIcon = docService.getDocumentGlancebilityIcon
         scope.displayWarningGlanceability = docService.displayWarningGlanceability
         scope.getWarningGlanceabilityPublications = docService.getWarningGlanceabilityPublications
         scope.getWarningGlanceabilityNotices = docService.getWarningGlanceabilityNotices
         scope.checkGlanceabilityEnablmentFromCustomizer = docService.checkGlanceabilityEnablmentFromCustomizer
         scope.displaySecondaryPublicationsTypesSeparator = docService.displaySecondaryPublicationsTypesSeparator
         scope.displaySecondaryNoticeTypesSeparator = docService.displaySecondaryNoticeTypesSeparator
         scope.showVideoLink = docService.showVideoLink(doc)
         // HACK: remove this once URIs are accessible via IEDL through API
         if (scope.showVideoLink) { scope.videoLink = docService.getVideoLink(doc) }

         scope.syndeticsIsbn = doc.isbn
         doc.databases = quickLookService.setDatabases(doc)

         scope.computedVals = docService.getComputedValues(doc)

         doc.simple_title = docService.getSimpleTitle(doc.title)
         doc.journalCoverageSummary = journalCoverageDetailsService.getJournalCoverageSummary(doc)
         scope.showJournalCoverage = journalCoverageDetailsService.isJournalCoverageAvailable(doc) && resultsConfig.displayJournalCoverageRanges
    
         if (hasIssns) {
            const issn = doc.issns[0]
            doc.eJournalLink = journalCoverageDetailsService.getJournalConverageDetailEJournalLink(libHash,issn)
         }

         scope.isAlmaClient = resultsConfig.isAlmaClient
     
         if (scope.isAlmaClient) {
            const anyAlmaUrl = config.data.alma.ill || config.data.alma.suprima || config.data.alma.citation_linker || config.data.alma.journal_search
            if (anyAlmaUrl) {
               const almaBaseUrl = new URL(anyAlmaUrl).hostname
               const almaInstitutionCode = resultsConfig.almaId
               const ieId = doc.external_document_id
               return doc.eJournalLinkSOA = journalCoverageDetailsService.getJournalConverageDetailEJournalLinkSOA(almaBaseUrl,almaInstitutionCode,ieId)
            }
         }
      }
   }
})
  

// used in DocumentCiteAction & DocumentEmailAction directives
const DocumentCitation = () => ({
   replace: true,
   templateUrl: '/assets/documentCitation.html'
})

const DocumentAction = (dialog: DialogService, alerts: AlertService, translationService: TranslationService) => ({
   replace: true,
   templateUrl: '/assets/documentAction.html',

   scope: {
      documents: '=',
      openClickTrackLink: '=',
      openPage: '=',
      search: '=',
      action: '@' // 'email' OR 'citation'
   },

   link(scope: any) {
      if(scope.action == 'citation') {
         scope.translation = translationService.translations.CITE_THIS_ITEM
         scope.showExportOptions = true
         scope.displayDialog = function(event: any){
            const {
               currentTarget
            } = event
            alerts.resetAlert('citationError')
            return dialog.displayDialog('cite', scope, (modal: any) => scope.close = modal.close).then(function() {
               if (currentTarget != null) { return currentTarget.focus() }
            }, function() {
               if (currentTarget != null) { return currentTarget.focus() }
            })
         }
      } else if(scope.action == 'email') {
         scope.translation = translationService.translations.EMAIL_THIS_ITEM
         scope.displayDialog = function(event: any){
            const {
               currentTarget
            } = event
            alerts.resetAlert('citationError')
            alerts.resetAlert('citationEmailError')
            return dialog.displayDialog('email', scope, (modal: any) => scope.close = modal.close).then(function() {
               if (currentTarget != null) { return currentTarget.focus() }
            }, function() {
               if (currentTarget != null) { return currentTarget.focus() }
            })
         }
      } else if(scope.action == 'bulk_download') {
         scope.translation = translationService.translations.EXPORT_RESULTS
         scope.displayDialog = function(event: any){
            const {
               currentTarget
            } = event
            return dialog.displayDialog('bulkExport', scope, (modal: any) => scope.close = modal.close).then(function() {
               if (currentTarget != null) { return currentTarget.focus() }
            }, function() {
               if (currentTarget != null) { return currentTarget.focus() }
            })
         }
      }
      
      scope.getRecordCount = function () {
         return scope.$parent.feed.items[0]?.recordCount
      }
      scope.openDetailPage = function(document: any) {
         scope.close()
         return scope.openPage(document)
      }
      return scope.fieldSearch = function(type: any, author: any) {
         scope.close()
         return scope.search(type, author)
      }
   }
})
// @ts-expect-error TS(7006) FIXME: Parameter 'citation' implicitly has an 'any' type.
const MoreActions = (citation, menuManager) => ({
   replace: true,
   templateUrl: '/assets/moreActions.html',

   link(scope: any) {
      const name = 'moreActions' + scope.$id
      const config = { 
         name,
         type: 'dropdown',
         close: ['any']
      }
  
      menuManager.registerMenu(config)
      scope.onToggle = function(status: any) {
         if (status) {
            return menuManager.subMenu[name].openMenu()
         } else {
            return menuManager.subMenu[name].closeMenu()
         }
      }

      return scope.setExportOptions = function() {
         scope.exportOptions = citation.styles.export
         return citation.prepCitationExportOptions(scope.document, scope.exportOptions)
      }
   }
})

const Libguides = () => ({
   replace: true,

   scope: { libguides: '='
   },

   templateUrl: '/assets/libguides.html',

   link(scope: any) {
      scope.columns = []
      if (scope.libguides && scope.libguides.length) {
         if (scope.libguides.length <= 4) {
            return scope.columns.push(scope.libguides)
         } else {
            const first = Math.ceil(scope.libguides.length / 2)
            const last  = scope.libguides.length - first
            scope.columns.push(scope.libguides.slice(0, first))
            return scope.columns.push(scope.libguides.slice(first, first + last))
         }
      }
   }
})


angular.module('summonApp.directives')
   .directive('resultsFeed', ResultsFeed)
   .directive('document', DocumentDirective)
   .directive('documentSummary', ['documentService', 'quickLookService', 'configService', 'journalCoverageDetailsService', 'translationService', DocumentSummary])
   .directive('documentCitation', [DocumentCitation])
   .directive('documentAction', ['dialogService', 'alertService', 'translationService', DocumentAction])
   .directive('moreActions', ['citationService', 'menuManagerService', MoreActions])
   .directive('libguides', Libguides)

